
import React, { Component } from "react";
import {Layout } from "antd";
import NavHeader from "../../components/NavHeader";
import SiderMenuMain from "../../components/SiderMenuMain";
import NavFooter from "../../components/NavFooter";

import '../css/main.less'

import store from "store";
import NavBreadcrumb from "../../components/NavBreadcrumb";
import {AiReportProps, TaskProps} from "./model/aireport";
import TaskList from "./components/TaskList";
import AiInputForm from "./components/AiInputForm";

const { Content } = Layout;

interface IProps {
}

export default class TaskInput extends Component<IProps> {

    taskListRef: TaskList | undefined;
    onTaskListRef = (ref: TaskList) => {
        this.taskListRef = ref;
    }

    aiInputRef: AiInputForm | undefined;
    onAiInputRef = (ref: AiInputForm) => {
        this.aiInputRef = ref;
    }

    state = {
        dataYsybList: [],
        dataAiybList: [],
        dataCatalogTree: [],
        dataCatalogSub: [],

        showInputter: false,

        taskInfo: {} as TaskProps,
        loadingYsyb: false,
        loadingAiyb: false,

        aiReport: {} as AiReportProps
    }

    componentDidMount() {
    }

    render() {

        const crumb = [
            {name: '智能研报'},
            {name: '研报录入'},
        ];
        return (
            <Layout>
                <NavHeader/>
                <Content className={"main-body"}>
                    <Layout>
                        <SiderMenuMain/>
                        <Content className={'main-content'}>
                            <NavBreadcrumb itemList={crumb}/>

                            <TaskList ref={this.onTaskListRef}
                                      onEdit={this.openInputter}
                                      queryStatus={'1'}
                                      queryUser={store.get('login_info').user_id}
                            >
                            </TaskList>

                            <AiInputForm ref={this.onAiInputRef}
                                         onClose={this.closeInputter}
                            ></AiInputForm>

                        </Content>
                    </Layout>
                </Content>
                <NavFooter/>
            </Layout>


        );
    }

    openInputter = (task: TaskProps) => {
        console.log('onInputClick', task);
        this.aiInputRef?.openInputter(task);
    };
    closeInputter = (reload: boolean) => {
        if (reload) {
            this.taskListRef?.loadMainData();
        }
    };
}